module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-700.05d04c19.ttf";